import React from "react";
import styled from "@emotion/styled";

import helpIcon from "../../assets/icons/helpBtnIcon.svg";
import { Dropdown, Menu } from "antd";
import HelperMenu from "../monkHelper/HelperMenu";
import { fontFamiliy } from "./constant";

const CheckNutritionSection = ({ data }) => {
  const getHeightMeasureText = (d) => {
    if (!d) return "-";
    if (d === "severe_stunted") return "เตี้ยแคระแกร็น";
    if (d === "stunted") return "เตี้ย";
    if (d === "relatively_stunted") return "ค่อนข้างเตี้ย";
    if (d === "normal") return "ตามเกณฑ์";
    if (d === "quite_high") return "ค่อนข้างสูง";
    if (d === "high") return "สูง";

    return "-";
  };

  const getWeightMeasureText = (d) => {
    if (!d) return "-";
    if (d === "severe_wasted") return "ผอมแห้ง";
    if (d === "wasted") return "ผอม";
    if (d === "relatively_wasted") return "ค่อนข้างผอม";
    if (d === "normal") return "สมส่วน";
    if (d === "buxom") return "ท้วม";
    if (d === "overweight") return "เริ่มอ้วน";
    if (d === "obese") return "อ้วน";

    return "-";
  };

  const getHeightMeasureColor = (d) => {
    if (!d) return;
    if (d === "severe_stunted") return "#fa0004";
    if (d === "stunted") return "#fb5609";
    if (d === "relatively_stunted") return "#f8b306";
    if (d === "normal") return "#84c83f";
    if (d === "quite_high") return "#84c83f";
    if (d === "high") return "#84c83f";

    return;
  };

  const getWeightMeasureColor = (d) => {
    if (!d) return;
    if (d === "severe_wasted") return "#fa0004";
    if (d === "wasted") return "#fb5609";
    if (d === "relatively_wasted") return "#f8b306";
    if (d === "normal") return "#84c83f";
    if (d === "buxom") return "#f8b306";
    if (d === "overweight") return "#fb5609";
    if (d === "obese") return "#fa0004";

    return;
  };

  return (
    <CheckNutritionContainer>
      <CNLabel>ภาวะโภชนาการ</CNLabel>
      <NutritionContainer>
        <NutritionCard>
          <NutritionCardInnerContainer>
            <NutritionHeader>น้ำหนัก</NutritionHeader>
            <br />
            <NutritionData>{data.weight} กก.</NutritionData>
          </NutritionCardInnerContainer>
        </NutritionCard>
        <NutritionCard>
          <NutritionCardInnerContainer>
            <NutritionHeader>ส่วนสูง</NutritionHeader>
            <br />
            <NutritionData>{data.height} ซม.</NutritionData>
          </NutritionCardInnerContainer>
        </NutritionCard>
      </NutritionContainer>
      <NutritionContainer>
        <NutritionCard>
          <NutritionCardInnerContainer>
            <NutritionHeader>น้ำหนักตามเกณฑ์ส่วนสูง​</NutritionHeader>
            <br />
            <NutritionData color={getWeightMeasureColor(data.weightForHeight)}>
              {getWeightMeasureText(data.weightForHeight)}
            </NutritionData>
          </NutritionCardInnerContainer>
        </NutritionCard>
        <NutritionCard>
          <NutritionCardInnerContainer>
            <NutritionHeader>ส่วนสูงตามเกณฑ์อายุ​</NutritionHeader>
            <br />
            <NutritionData color={getHeightMeasureColor(data.heightForAge)}>
              {getHeightMeasureText(data.heightForAge)}
            </NutritionData>
          </NutritionCardInnerContainer>
        </NutritionCard>
      </NutritionContainer>
      {/* <HeightWeightMeasureLabel>
        ส่วนสูงตามเกณฑ์อายุ​ :{" "}
        <HeightWeightMeasureData>
          {getHeightMeasureText(data.heightForAge)}
        </HeightWeightMeasureData>
      </HeightWeightMeasureLabel>
      <br />
      <HeightWeightMeasureLabel>
        น้ำหนักตามเกณฑ์ส่วนสูง​ :{" "}
        <HeightWeightMeasureData>
          {getWeightMeasureText(data.weightForHeight)}
        </HeightWeightMeasureData>
      </HeightWeightMeasureLabel> */}
      <Dropdown overlay={<HelperMenu />} placement="topLeft" arrow>
        <HelperButton>
          <img src={helpIcon} style={{ marginRight: "8px" }} />
          ทำไม่ถึงเป้าหมายขอตัวช่วย
        </HelperButton>
      </Dropdown>
    </CheckNutritionContainer>
  );
};

const CheckNutritionContainer = styled.div`
  font-family: ${fontFamiliy};
`;

const CNLabel = styled.span`
  margin-left: 24px;

  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  /* identical to box height, or 144% */

  /* Primary/Green 500 */

  color: #058459;
`;

const NutritionContainer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: space-between;
  margin-top: 8px;
  margin-bottom: 16px;
`;

const NutritionCard = styled.div`
  background-color: #f1f1f1;
  width: calc((440px - 16px) / 2);
  text-align: center;
  border-radius: 8px;
`;

const NutritionCardInnerContainer = styled.div`
  padding-top: 14px;
  padding-bottom: 14px;
`;

const NutritionHeader = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  /* identical to box height, or 162% */

  text-align: center;

  /* Neutral / 600 */

  color: #4b5768;
`;

const NutritionData = styled.span`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  /* identical to box height, or 156% */

  text-align: center;

  /* Neutral / 600 */

  color: ${(props) => (props.color ? props.color : "#4b5768")};
`;

const HeightWeightMeasureLabel = styled.span`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  /* identical to box height, or 162% */

  /* Neutral / 600 */

  color: #4b5768;
`;

const HeightWeightMeasureData = styled.span`
  font-size: 16px;
  font-weight: 400;
`;

const HelperButton = styled.div`
  margin-top: 16px;
  border-radius: 100px;
  background: #b5f6df;
  /* Primary/Green 400 */
  text-align: center;
  border: 1px solid #16af7b;
  font-weight: 600;
  font-size: 19px;
  color: #16af7b;
  cursor: pointer;
  padding-top: 14px;
  padding-bottom: 14px;
`;

export default CheckNutritionSection;
